module.exports={
	"Hash": "london-subway",
	"Name": "London Subway",
	"Version": "1.0.0",
	"Description": "London Underground signage: corporate blue and roundel red over clean white, with Tube line colours.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#161c2b"
				},
				"Secondary": {
					"Light": "#f1f4f8",
					"Dark": "#1e2638"
				},
				"Tertiary": {
					"Light": "#e9eef4",
					"Dark": "#242e44"
				},
				"Panel": {
					"Light": "#f8fafc",
					"Dark": "#1a2233"
				},
				"Hover": {
					"Light": "#eef2f7",
					"Dark": "#2a3550"
				},
				"Selected": {
					"Light": "#dce6f7",
					"Dark": "#33436e"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#0b1f4d",
					"Dark": "#ffffff"
				},
				"Secondary": {
					"Light": "#34507e",
					"Dark": "#cdd7e6"
				},
				"Muted": {
					"Light": "#5b6b86",
					"Dark": "#9fb0c8"
				},
				"Placeholder": {
					"Light": "#8492a8",
					"Dark": "#6f7f99"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0019a8",
					"Dark": "#3f74d6"
				},
				"PrimaryHover": {
					"Light": "#001488",
					"Dark": "#5a8ce4"
				},
				"Accent": {
					"Light": "#dc241f",
					"Dark": "#dc241f"
				}
			},
			"Border": {
				"Light": "#dde3ec",
				"Dark": "#30405e"
			},
			"Status": {
				"Success": {
					"Light": "#007229",
					"Dark": "#00a100"
				},
				"Warning": {
					"Light": "#b36305",
					"Dark": "#e0a030"
				},
				"Error": {
					"Light": "#dc241f",
					"Dark": "#dc241f"
				},
				"Info": {
					"Light": "#0098d4",
					"Dark": "#0098d4"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f1f4f8",
					"Dark": "#1e2638"
				},
				"Thumb": {
					"Light": "#dde3ec",
					"Dark": "#30405e"
				},
				"Hover": {
					"Light": "#5b6b86",
					"Dark": "#9fb0c8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#0019a8",
					"Dark": "#dc241f"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0019a8",
					"Dark": "#3f74d6"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
